import { useState } from 'react'
import { IconButton, TableCell, TableRow, Link, Chip } from '@mui/material'
import { EditIcon, DeleteIcon } from 'components/Icons'
import Confirm from 'components/Dialog'
import { useDispatch } from 'react-redux'
import { destroy } from 'store/provider/academic-year'
import { Link as NavLink } from 'react-router-dom'
import { useBasePath } from 'components/Providers'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

export default function AcademicYearItem({ item }) {
  const [confirm, setConfirm] = useState(false)
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const { t } = useTranslation()

  const onConfirm = () => {
    setConfirm(false)
    dispatch(destroy({ id: item.id }))
  }

  return (
    <TableRow hover key={item.id}>
      <TableCell>{item.id}</TableCell>
      <TableCell>
        <Link component={NavLink} underline="hover" color="inherit" to={`${basePath}/${item.id}`}>
          {item.name}
        </Link>
      </TableCell>
      <TableCell>
        {item.isFullYear ? (
          <Chip label={t('School Year')} color="success" sx={{ mr: 2 }} size="small" />
        ) : (
          <Chip label={t('Summer School')} color="primary" sx={{ mr: 2 }} size="small" />
        )}
      </TableCell>
      <TableCell>{dayjs(item.startDate).format('MM-DD-YYYY')}</TableCell>{' '}
      <TableCell>{dayjs(item.endDate).format('MM-DD-YYYY')}</TableCell>{' '}
      <TableCell sx={{ pl: 1 }}>
        <IconButton
          onClick={() => {
            setConfirm(true)
          }}
        >
          <DeleteIcon />
        </IconButton>
        <IconButton component={NavLink} to={`${basePath}/${item.id}/edit`}>
          <EditIcon />
        </IconButton>
      </TableCell>
      <Confirm open={confirm} onClose={() => setConfirm(false)} onConfirm={onConfirm} />
    </TableRow>
  )
}
